export const MAX_FIELD_LENGTH = 255;
export const REQUIRED_PAYMENT_NOTIFICATION_FIELD = "detailedStatus";
